import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Facebook, Twitter, Linkedin, Youtube, Instagram, ArrowUp } from "lucide-react";
import { getSiteConfig } from "@/lib/api";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_df2c336a-cf24-4860-adef-adda9eebb723/artifacts/c9aru5vi_Color%20Logo.png";
const SOCIAL_ICONS = { facebook: Facebook, twitter: Twitter, linkedin: Linkedin, youtube: Youtube, instagram: Instagram };

export default function Footer() {
  const [cfg, setCfg] = useState(null);

  useEffect(() => {
    getSiteConfig("footer").then(r => setCfg(r.data?.data || {})).catch(() => {});
  }, []);

  const scrollToTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  const handleLinkClick = (href) => {
    if (href.startsWith("/#")) {
      const el = document.getElementById(href.replace("/#", ""));
      if (el) el.scrollIntoView({ behavior: "smooth" });
    }
  };

  const description = cfg?.description || "Unité de Recherche et d'Innovation en Élevage Biologique et Gestion Durable des Ressources Zoogénétiques.";
  const quickLinks = cfg?.quick_links || [];
  const socialLinks = cfg?.social_links || [];
  const copyright = cfg?.copyright || "UR-EBioReZ – Tous droits réservés";

  return (
    <footer data-testid="footer" className="bg-gradient-to-br from-[#0f2a4a] to-[#1670B9]/90 text-white">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          <div>
            <img src={LOGO_URL} alt="UR-EBioReZ" className="h-12 w-auto mb-4 brightness-0 invert" />
            <p className="text-sm text-white/60 leading-relaxed max-w-xs">{description}</p>
          </div>
          <div>
            <h3 className="font-['Quicksand'] text-base font-semibold mb-5">Liens rapides</h3>
            <ul className="space-y-3">
              {quickLinks.map((link, i) => (
                <li key={`ql-${link.label}-${i}`}>
                  {link.href.startsWith("/") && !link.href.startsWith("/#") ? (
                    <Link to={link.href} className="text-sm text-white/60 hover:text-white transition-colors">{link.label}</Link>
                  ) : (
                    <button onClick={() => handleLinkClick(link.href)} className="text-sm text-white/60 hover:text-white transition-colors">{link.label}</button>
                  )}
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h3 className="font-['Quicksand'] text-base font-semibold mb-5">Contact</h3>
            <div className="space-y-2 text-sm text-white/60 mb-6">
              {cfg?.phone1 && <p>{cfg.phone1}</p>}
              {cfg?.phone2 && <p>{cfg.phone2}</p>}
              {cfg?.email && <p>{cfg.email}</p>}
            </div>
            <div className="flex gap-3">
              {socialLinks.map((s, i) => {
                const IconComp = SOCIAL_ICONS[s.platform] || Facebook;
                return (
                  <a key={`social-${s.platform}`} href={s.url || "#"} target="_blank" rel="noopener noreferrer" className="w-9 h-9 rounded-lg bg-white/10 flex items-center justify-center hover:bg-white/20 transition-colors" aria-label={s.platform} data-testid={`social-${s.platform}`}>
                    <IconComp className="w-4 h-4" />
                  </a>
                );
              })}
            </div>
          </div>
        </div>
        <div className="mt-12 pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-xs text-white/40" data-testid="footer-copyright">&copy; {new Date().getFullYear()} {copyright}</p>
          <button onClick={scrollToTop} className="w-10 h-10 rounded-xl bg-white/10 flex items-center justify-center hover:bg-white/20 transition-colors" aria-label="Retour en haut" data-testid="scroll-to-top">
            <ArrowUp className="w-4 h-4" />
          </button>
        </div>
      </div>
    </footer>
  );
}
